import { render, staticRenderFns } from "./RgWarrantiesList.vue?vue&type=template&id=6f07c847&scoped=true"
import script from "./RgWarrantiesList.vue?vue&type=script&lang=js"
export * from "./RgWarrantiesList.vue?vue&type=script&lang=js"
import style0 from "./RgWarrantiesList.vue?vue&type=style&index=0&id=6f07c847&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07c847",
  null
  
)

export default component.exports